import React, { useState, useEffect, memo } from "react";
import "./chefs.css";
import AdminTabs from "../adminTabs";
import ChefComponent from "./ChefComponent";
import { ThreeCircles } from "react-loader-spinner";
import ChefMenuModal from "./ChefMenuModal";
import ConfirmPopupModal from "./ConfirmPopupModal";
import SelectLocationModal from "./SelectLocationModal";
import ProfilePopupModal from "./ProfilePopupModal";
import ChefEmiHistoryPopup from "./ChefEmiHistoryPopup";
import ChefPerformancePopup from "./ChefPerformancePopup";
import ChefMenuCountPopup from "./ChefMenuCountPopup";
import VerifiedChefComponent from "./VerifiedChefComponent";
import {
  handleVerify,
  handleStatus,
  handleUpdateChef,
  handleChefImageUpload,
  handleChefDescUpdate,
  handleKitchenImagesUpload,
  handlePerformance,
  handleMenuCount,
  handleEmiStatus,
  handleShowMenu,
  handleUnverify,
  handleChefStatus,
  getChefStatusCounts,
  handleCraverNotifications,
  handleChefChat,
  saveKitchenLoc,
  getPodLocations
} from "./services";
import ChefImageModal from "./ChefImageModal";
import KitchenImagesModal from "./kitchenImagesModal";
import ChefProfileDescPopup from "./ChefProfileDescPopup";
import ChefChatPopup from "./ChefChatPopup";

const Chefs = () => {
  const [key, setKey] = useState("");
  const [loading, setLoading] = useState(true);
  const [showMenuModal, setShowMenuModal] = useState(false);
  const [selectedChefData, setSelectedChefData] = useState(null);
  const [selectedChefMenu, setSelectedChefMenu] = useState([]);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [showUnVerifyPopup, setShowUnVerifyPopup] = useState(false);
  const [showUpdatedLocPopup, setShowUpdatedLocPopup] = useState(false);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [showChefImagePopup, setShowChefImagePopup] = useState(false);
  const [showChefDescPopup, setShowChefDescPopup] = useState(false);
  const [showKitchenImagesPopup, setShowKitchenImagesPopup] = useState(false);
  const [chefsEMIData, setChefsEMIData] = useState(null);
  const [showEmiPopup, setShowEmiPopup] = useState(false);
  const [chefName, setChefName] = useState(null);
  const [chefLevelData, setChefLevelData] = useState([]);
  const [chefPerformance, setChefPerformance] = useState(null);
  const [chefMenuCount, setChefMenuCount] = useState(null);
  const [showPerformance, setShowPerformance] = useState(false);
  const [showMenuCount, setShowMenuCount] = useState(false);
  const [showActive, setShowActive] = useState(true);
  const [podLocations, setPodLocations] = useState([])
  const [showChefChat, setShowChefChat] = useState(false);
  const [count, setCount] = useState({
    Registered: 0,
    Contacted: 0,
    Training: 0,
    "Menu/Catalog": 0,
    "Audit/Sample": 0,
    Verified: 0,
    Removed: 0,
  });

  const chefTypes = [
    "Registered",
    "Contacted",
    "Training",
    "Menu/Catalog",
    "Audit/Sample",
    "Verified",
    "Removed",
  ];

  const tabData = [
    { id: "Registered", title: "Registered", count: count.Registered },
    { id: "Contacted", title: "Contacted", count: count.Contacted },
    { id: "Training", title: "Training", count: count.Training },
    { id: "Menu/Catalog", title: "Menu/Catalog", count: count["Menu/Catalog"] },
    { id: "Audit/Sample", title: "Audit/Sample", count: count["Audit/Sample"] },
    { id: "Verified", title: "Verified", count: count.Verified },
    { id: "Removed", title: "Removed", count: count.Removed },
  ];
  const [lastUserID, setLastUserID] = useState(null);

  useEffect(() => {
    getPodLocations(setPodLocations)
  },[])

  useEffect(() => {},[chefLevelData])

  
  useEffect(() => {
    const getActiveTab = JSON.parse(localStorage.getItem("activeTab"));
    if (getActiveTab) {
      setKey(getActiveTab);
    }
  }, []);

  useEffect(() => {
    if (key !== "") {
      setLoading(true);
      localStorage.setItem("activeTab", JSON.stringify(key));
      handleStatus(key, setChefLevelData, setLoading, setLastUserID, null)
    }
  }, [key]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (lastUserID && lastUserID !== null && lastUserID !== "") {
        handleStatus(key, setChefLevelData, setLoading, setLastUserID, lastUserID);
      } else {
        return;
      }
    }, 2000);
  
    return () => clearInterval(intervalId);
  }, [lastUserID]);
  

  useEffect(() => {
    getChefStatusCounts(setCount, setLoading);
  }, []);

  const RenderTabs = memo(({ id, title, count }) => {
    return (
      <li className="nav-item">
        <a
          className={key === id ? classNameActive : classNameInactive}
          id={`${id}-tab`}
          data-toggle="tab"
          href={`#${id}`}
          role="tab"
          onClick={() => {
            setChefLevelData([]);
            setKey(id);
          }}
          aria-controls={id}
          aria-selected="true"
        >
          {title} {count}
        </a>
      </li>
    );
  });

  const RenderComponent = memo(({ id, children }) => {
    return id === key ? (
      <div
        className={
          key === id ? classNameActiveComponent : classNameInactiveComponent
        }
        id={id}
        role="tabpanel"
        aria-labelledby={`${id}-tab`}
      >
        {children}
      </div>
    ) : null;
  });

  useEffect(() => {
    if (selectedChefMenu !== null && selectedChefMenu.length > 0) {
      setShowMenuModal(true);
    } else {
      setShowMenuModal(false);
    }
  }, [selectedChefMenu]);

  const handleCross = () => {
    setSelectedChefData(null);
    setSelectedChefMenu(null);
  };

  const handleVerifyChef = (data) => {
    setShowVerifyPopup(true);
    setSelectedChefData(data);
  };

  const handleUnVerifyChef = (data) => {
    setShowUnVerifyPopup(true);
    setSelectedChefData(data);
  };

  const handleChefLocation = (data) => {
      setShowUpdatedLocPopup(true);
    setSelectedChefData(data);
  }

  const handleProfileUpdate = (data) => {
    setSelectedChefData(data);
    setShowProfilePopup(true);
  };

  const handleChefImage = (data) => {
    setSelectedChefData(data);
    setShowChefImagePopup(true);
  }

  const handleChefDesc = (data) => {
    setSelectedChefData(data);
    setShowChefDescPopup(true);
  }

  const handleKitchenImages = (data) => {
    setSelectedChefData(data);
    setShowKitchenImagesPopup(true);
  }

  const handleDismiss = () => {
    setShowVerifyPopup(false);
    setShowUpdatedLocPopup(false);
    setShowUnVerifyPopup(false);
    setShowProfilePopup(false);
    setShowChefImagePopup(false);
    setShowChefDescPopup(false);
    setShowKitchenImagesPopup(false);
    setShowEmiPopup(false);
    setChefsEMIData(null);
    setChefName(null);
    setChefPerformance(null);
    setChefMenuCount(null);
    setShowPerformance(false);
    setShowMenuCount(false);
    setShowChefChat(false);
  };

  useEffect(() => {
    if (chefsEMIData !== null) {
      setShowEmiPopup(true);
    }
  }, [chefsEMIData]);

  useEffect(() => {
    if (chefPerformance !== null) {
      setShowPerformance(true);
    }
  }, [chefPerformance]);

  useEffect(() => {
    if (chefMenuCount !== null) {
      setShowMenuCount(true);
    }
  }, [chefMenuCount]);

  const handleConfirmPopup = (comments) => {
    handleVerify(selectedChefData, comments, setLoading, setShowVerifyPopup);
  };

  const UpdateChefProfile = (profilePicture) => {
    handleUpdateChef(selectedChefData, profilePicture, setLoading);
  };

  const updateChefImageUpload = (chefImage) => {
    handleChefImageUpload(selectedChefData, chefImage, setLoading);
  };

  const updateChefDescUpload = (chefDesc) => {
    setShowChefDescPopup(false);
    handleChefDescUpdate(selectedChefData, chefDesc, setLoading);
  }

  const updateKitchenImagesUpload = (kitchenImages) => {
    handleKitchenImagesUpload(selectedChefData, kitchenImages, setLoading);
  };

  const handleChefPerformance = (data, showActive) => {
    handlePerformance(
      data,
      showActive,
      setChefPerformance,
      setSelectedChefData
    );
  };

  const handleChefMenuCount = (data, showActive) => {
    handleMenuCount(
      data,
      setChefMenuCount,
      setSelectedChefData
    );
  };

  const handleEmi = (data) => {
    handleEmiStatus(data, setChefsEMIData, setChefName, setLoading);
  };

  const ShowMenu = (data) => {
    handleShowMenu(data, setSelectedChefData, setSelectedChefMenu);
  };

  const UnverifyChef = (comments) => {
    handleUnverify(comments, selectedChefData, setLoading);
  };

  const ChefStatus = (status, comments, data) => {
    if(status.toUpperCase() === "REGISTERED") {
      handleChefStatus("", comments, data, setLoading);
    } else {
      handleChefStatus(status, comments, data, setLoading);
    }
   
  };

  const onChefChatSubmit = ({ target, chatReason}) => {
    setLoading(true);
    const dataToPost = {
      "destination": selectedChefData.userMobile,
      "agent": target.toUpperCase(),
      "params": JSON.stringify([selectedChefData.userName, chatReason])
    }
    setShowChefChat(false);
    handleChefChat(dataToPost, setLoading);
  }

  let classNameInactive = "nav-link";
  let classNameActive = "nav-link active show";
  let classNameInactiveComponent = "tab-pane fade";
  let classNameActiveComponent = "tab-pane fade show active";

  const handleInitiateChefChat = (data) => {
    setSelectedChefData(data);
    setShowChefChat(true);
  }

  const handleSelectedLoc = (data) => {
  setLoading(true);

  const podData = {
    podID: data?.podID || "",
    podName: data?.podName || "",
  };

  const dataToPut = {
    ...podData,
    userID: selectedChefData.userID,
  };

  const message = podData.podID
    ? "Are you sure you want to assign this Pod Location?"
    : "Are you sure you want to unassign the Pod Location?";

  const confirmed = window.confirm(message);

  if (confirmed) {
    saveKitchenLoc(dataToPut);
  } else {
    setLoading(false);
  }
};



  return (
      <AdminTabs >
        <div className="chefs">
          {loading && (
            <div className="spinnerContainer">
              <div className="spinner">
                <ThreeCircles
                  color="blue"
                  height={110}
                  width={110}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          )}
          {showMenuModal && selectedChefData !== null && (
            <ChefMenuModal
              show={showMenuModal}
              selectedChefData={selectedChefData}
              handleClose={handleCross}
            />
          )}
          {showVerifyPopup && (
            <ConfirmPopupModal
              heading="Are you sure you want to verify the chef?"
              show={showVerifyPopup}
              handleConfirmPopup={handleConfirmPopup}
              handleDismiss={handleDismiss}
              buttonText="Verify Chef"
            />
          )}
          {showUnVerifyPopup && (
            <ConfirmPopupModal
              heading="Are you sure you want to unverify the chef?"
              show={showUnVerifyPopup}
              handleConfirmPopup={UnverifyChef}
              handleDismiss={handleDismiss}
              buttonText="Un Verify Chef"
            />
          )}
          {showUpdatedLocPopup && (
             <SelectLocationModal
                selectedChefData={selectedChefData}
                show={showUpdatedLocPopup}
                handleClose={() => setShowUpdatedLocPopup(false)}
                locations={podLocations}
                handleSelectedLoc={handleSelectedLoc}
              />
                  )}
            {showProfilePopup && (
            <ProfilePopupModal
              data={selectedChefData}
              show={showProfilePopup}
              handleUpdateChef={UpdateChefProfile}
              handleDismiss={handleDismiss}
              loading={loading}
            />
          )}
          {showChefImagePopup && (
            <ChefImageModal
              data={selectedChefData}
              show={showChefImagePopup}
              handleUpdateChef={updateChefImageUpload}
              handleDismiss={handleDismiss}
              loading={loading}
            />
          )}
          {showChefDescPopup && (
            <ChefProfileDescPopup
              data={selectedChefData}
              show={showChefDescPopup}
              updateChefDescUpload={updateChefDescUpload}
              handleDismiss={handleDismiss}
            />
          )}
           {showKitchenImagesPopup && (
            <KitchenImagesModal
              data={selectedChefData}
              show={showKitchenImagesPopup}
              handleUpdateKitchen={updateKitchenImagesUpload}
              handleDismiss={handleDismiss}
              loading={loading}
            />
          )}
          {showEmiPopup && chefsEMIData !== null && (
            <ChefEmiHistoryPopup
              data={chefsEMIData}
              show={showEmiPopup}
              chefName={chefName}
              handleDismiss={handleDismiss}
            />
          )}
          {showPerformance && chefPerformance !== null && (
            <ChefPerformancePopup
              data={chefPerformance}
              show={showPerformance}
              selectedChefData={selectedChefData}
              handleDismiss={handleDismiss}
            />
          )}
          {showMenuCount && chefMenuCount !== null && (
            <ChefMenuCountPopup
              data={chefMenuCount}
              show={showMenuCount}
              selectedChefData={selectedChefData}
              handleDismiss={handleDismiss}
            />
          )}
           {showChefChat ? (
            <ChefChatPopup
              show={showChefChat}
              selectedChefData={selectedChefData}
              handleDismiss={handleDismiss}
              handleChefChat={onChefChatSubmit}
            />
          ) : null}
          <ul className="nav nav-tabs listgroup" id="myTab" role="tablist">
            {tabData.map((tab) => (
              <RenderTabs
                key={tab.id}
                id={tab.id}
                title={tab.title}
                count={tab.count}
              />
            ))}
          </ul>
          <div className="tab-content" id="myTabContent">
            {chefTypes.map((type) => (
              <RenderComponent
                key={type}
                id={type}
                children={
                  type === "Verified" ?
                  <VerifiedChefComponent
                    type={type}
                    handleChefLocation={handleChefLocation}
                    handleShowMenu={ShowMenu}
                    handleUnVerifyChef={handleUnVerifyChef}
                    handleChefStatus={ChefStatus}
                    handleProfileUpdate={handleProfileUpdate}
                    handleChefImage={handleChefImage}
                    handleChefDesc={handleChefDesc}
                    handleKitchenImages={handleKitchenImages}
                    handleEmiStatus={handleEmi}
                    handlePerformance={handleChefPerformance}
                    handleMenuCount={handleChefMenuCount}
                    handleCraverNotifications={handleCraverNotifications}
                    chefLevelData={chefLevelData}
                    showActive={showActive}
                    setShowActive={setShowActive}
                    handleInitiateChefChat={handleInitiateChefChat}
                    podLocations={podLocations}
                  /> 
                  : 
                  <ChefComponent
                  type={type}
                  handleUnVerifyChef={handleUnVerifyChef}
                  handleChefStatus={ChefStatus}
                  handleVerifyChef={handleVerifyChef}
                  chefLevelData={chefLevelData}
                  handleInitiateChefChat={handleInitiateChefChat}
                />
                }
              />
            ))}
          </div>
        </div>
      </AdminTabs>
  );
};
export default Chefs;
